import mixpanel from 'mixpanel-browser';

import { isLocal } from '~/shared/utils/environments';

const MIXPANEL_TOKEN = process.env.NEXT_PUBLIC_MIXPANEL_TOKEN;

export const initMixpanel = () => {
    if (isLocal()) {
        return;
    }

    if (!MIXPANEL_TOKEN) {
        console.warn('Mixpanel token is missing! Check your .env file.');
        return;
    }

    mixpanel.init(MIXPANEL_TOKEN, {
        autocapture: false,
        track_pageview: true,
        persistence: 'localStorage',
        debug: false,
        record_sessions_percent: 100,
        record_idle_timeout_ms: 5 * 60 * 1000,
        record_mask_text_selector: '',
        record_block_selector: '',
    });
};
